import {
  TRANSACTION_ACCEPTED_ATTEMPT,
  TRANSACTION_ACCEPTED_SUCCESS,
  TRANSACTION_ACCEPTED_FAILED
} from "../types/transactionAcceptedTypes";

const INITIAL_STATE = {
  loading: false,
  list: [],
  error: "",
  page_size: 0,
  page_count: 0
};
function transactionAccepted(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TRANSACTION_ACCEPTED_ATTEMPT:
      return {
        ...state,
        loading: true
      };

    case TRANSACTION_ACCEPTED_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.data.list,
        page_size: action.data.size,
        page_count: state.page_count + action.data.size,
        error: ""
      };

    case TRANSACTION_ACCEPTED_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        list: []
      };

    default:
      return state;
  }
}
export default transactionAccepted;
